module.exports = ['lots.header_search.m12', 'lots.header_search.m13', 'marketplace.searchbars.common.facetsselect.m1', 'search.filters.freshness.m1'];
